/**
 * Blend the two server phases of a processing batch into one monotonic bar:
 * per-doc extraction fills 0–70%, the project analysis that follows fills
 * 70–100%. Pure — unit-tested in progress.test.ts.
 */ export function blendedPercent(status) {
    const docPct = status.progress?.percentage ?? 0;
    const analysisPct = status.projectAnalysisProgress?.percentage ?? 0;
    if (status.status !== 'completed') return Math.round(docPct * 0.7);
    return Math.round(70 + analysisPct * 0.3);
}
